import React from 'react'
import useStyles from './InvitationComponent.styles'
import { InvitationComponentProps } from './InvitationComponentProps'
import ResponsiveImage from '../../utils/ResponsiveImage'
import NeonLink from '../../utils/NeonLink'

const InvitationComponent: React.FC<InvitationComponentProps> = ({
  header,
  text,
  button,
  image,
  mobileImage
}) => {
  const classes = useStyles()

  const content = (
    <div className={classes.invitationOverlay}>
      <NeonLink className={classes.logo} />
      <div className={classes.header}>{header}</div>
      <div className={classes.text}>{text}</div>
      <a href={button.href} className={classes.signUpButton}>
        {button.text}
      </a>
    </div>
  )

  return (
    <>
      <ResponsiveImage
        src={image.src}
        mobileSrc={mobileImage?.src ?? image.src}
        className={classes.invitationImage}
        overlayClassName={classes.responsiveOverlay}
      >
        <div className={classes.invitationSplit}>
          {content}
        </div>
      </ResponsiveImage>

      <div className={classes.invitationContent}>
        {content}
      </div>
    </>
  )
}

export default InvitationComponent
